import CreateGalleryContainer from "@containers/dashboard/gallery/create";
import DashboardLayout from "@layouts/dashboard";

const CreateGallery = () => {
    return (
        <DashboardLayout title="گالری جدید">
            <CreateGalleryContainer />
        </DashboardLayout>
    );
};

export default CreateGallery;
